import React from 'react';
import { get } from 'lodash';
import { SERVICE_RESPONSE_STATUS } from 'constants/common';
import { withRouter } from 'react-router-dom';

// React view component to render
import { actionWidgetItemDetailSummary as ActionWidgetItemDetailSummaryView } from 'ui/views/widgets/actionWidgetItemDetailSummary';
import { ActionWidgetItemDetailSummaryService } from 'services/actionWidgetItemDetailSummary';
import { DASHBOARD_SUB_ROUTES } from 'constants/route-paths';

/**
 * @type {class}
 * @desc A React container/smart component to render a React presentational/dumb component (view).
 * @example
 * import { ActionWidgetItemDetailSummary } from 'ui/containers/ActionWidgetItemDetailSummary';
 *
 * // render
 * <ActionWidgetItemDetailSummary propName='propValue'/>
 */
export class _ActionWidgetItemDetailSummary extends React.Component {
    
    /**
     * @param {object} props - props
     */
    constructor( props ) {
        super( props );
        
         // component state
         this.state = {
            isFetching: true,
            networkStatus: undefined,
            componentData: undefined,
        };

        // bind methods
        this.handleActionClick = this.handleActionClick.bind( this );

        // create service instance
        this.actionWidgetItemDetailSummaryService = new ActionWidgetItemDetailSummaryService();
        
        // start data fetch
        this.fetchComponentData();
    }

    /**
     * @desc Fetch component response.
     */
    async fetchComponentData() {
        log.debug( 'actionWidgetItemDetailSummaryService.fetchComponentData()' );

        // cancel ongoing request
        this.actionWidgetItemDetailSummaryService.cancel();

        // fetch component data
        const { status, data } = await this.actionWidgetItemDetailSummaryService.fetchComponentData(  {
            url: this.props.widget.url,
            data: { ...this.props.requestPayload }
        } );

        // check if response status was success
        if( SERVICE_RESPONSE_STATUS.SUCCESS !== status ) {
            this.setState( {
                isFetching: false,
                networkStatus: SERVICE_RESPONSE_STATUS.FAILURE
            } );
        } else {
            this.setState( {
                isFetching: false,
                networkStatus: SERVICE_RESPONSE_STATUS.SUCCESS,
                componentData: data,
            } );
        }
    }

     /**
     * @desc Action handler for column action and group action.
     */
    handleActionClick( { type = 'column', value = {}, item = {} } = {} ) {
        log.debug( 'ActionWidgetItemDetailSummary.handleActionClick()' ); // @TODO: remove

        if( 'column' === type && 'memberId' === value.name ) {
            this.props.history.push( {
                pathname: DASHBOARD_SUB_ROUTES.MEMBER_MANAGEMENT,
                state: { memberId: item.id }
            } );
        }

        // if( 'column' === type ) {
        //     this.props.history.push( {
        //         pathname: DASHBOARD_SUB_ROUTES.CALL_DETAIL,
        //         search: queryString.stringify( {
        //             actionId: item.values.actionId,
        //         }  )
        //     } );
        // }
    }

    /**
     * @desc Render a React view component
     */
    render() {
        return (
            <ActionWidgetItemDetailSummaryView
                isFetching={ this.state.isFetching }
                networkStatus={ this.state.networkStatus }
                componentData={ get( this.state, 'componentData', {} ) }
                onActionClick={  this.handleActionClick }
            />
        );
    }
}

// set display name
_ActionWidgetItemDetailSummary.displayName = 'ActionWidgetItemDetailSummary';

// set default props
_ActionWidgetItemDetailSummary.defaultProps = {};

// prop types
_ActionWidgetItemDetailSummary.propTypes = {};

/*********************************************/


// wrap container with router
export const ActionWidgetItemDetailSummary = withRouter( _ActionWidgetItemDetailSummary ) ;
